import { useQuery } from "@tanstack/react-query";
import { api, qs } from "@/lib/api";
import { displayName } from "@/lib/format";

interface Row {
  id: number;
  first_name: string | null;
  last_name: string | null;
  email?: string | null;
  primary_email?: string | null;
}

/** Names for the contacts a billing list shows (contacts_list ids=…, up to 500). Unknown or archived IDs fall back to "#id". */
export function useContactNames(ids: number[]) {
  const unique = [...new Set(ids.filter((n) => n > 0))].sort((a, b) => a - b).slice(0, 500);
  const q = useQuery({
    queryKey: ["contact-names", unique.join(",")],
    queryFn: () => api<{ contacts: Row[] }>("/api/v1/contacts" + qs({ ids: unique.join(","), limit: 500 })),
    enabled: unique.length > 0,
    staleTime: 60_000,
  });
  const byId = new Map((q.data?.contacts ?? []).map((c) => [c.id, c]));
  return (id: number | null | undefined) => {
    if (!id) return "—";
    const c = byId.get(id);
    return c ? displayName({ ...c, first_name: c.first_name, last_name: c.last_name, email: c.primary_email ?? c.email ?? undefined, id: c.id }) : `#${id}`;
  };
}
